import cookies from '../helpers/cookies';

export function enable() {
  cookies.set('FEATURE-ESSENTIAL', 'true', { sameSite: 'lax', expires: 365 });
}

export function disable() {
  cookies.set('FEATURE-ESSENTIAL', 'false', { sameSite: 'lax', expires: 365 });
}

export function set(value) {
  value ? enable() : disable();
}
